const session_expired = {
    title: '會話已過期',
    subtitle: '會話可能已過期，你已被退出登錄。請點擊下方按鈕重新登錄到管理控制台。',
    button: '重新登錄',
};
export default session_expired;
